export default __webpack_public_path__ + "static/media/dashboard-illustration.ccbecdf0.svg";